import { Link } from "react-router-dom";
import { Newspaper } from "lucide-react";

const BlogPage = () => {
  return (
    <div data-testid="blog-page" className="bg-[#0B1A3B] pt-16 md:pt-20">
      <section className="relative py-16 md:py-24 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B1A3B] via-[#0F2251] to-[#0B1A3B]" />
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#D4AF37]/[0.03] rounded-full blur-[100px]" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#D4AF37] mb-4">Campaign Updates</p>
          <h1 className="text-4xl sm:text-5xl font-black tracking-tight text-white mb-4">News & Updates</h1>
          <p className="text-lg text-white/50 max-w-2xl mx-auto">
            Stay informed about the campaign, policy updates, and events happening across Nevada.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24 relative">
        <div className="absolute inset-0 bg-[#0F2251]" />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center py-16 bg-white/[0.03] border border-white/10 p-8">
            <Newspaper className="w-16 h-16 mx-auto text-[#D4AF37] mb-6" />
            <h2 className="text-2xl font-bold text-white mb-4">Coming Soon</h2>
            <p className="text-white/40 mb-8 max-w-md mx-auto">
              We're working on exciting news and updates to share. Sign up to be the first to receive campaign news.
            </p>
            <Link to="/volunteer" data-testid="blog-volunteer-btn" className="inline-block px-8 py-4 bg-[#D4AF37] hover:bg-[#B5952F] text-black font-bold uppercase tracking-widest text-sm transition-all hover:-translate-y-0.5 hover:shadow-[0_20px_40px_-12px_rgba(212,175,55,0.3)]">
              Sign Up for Updates
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
